import React, {useState, useEffect, Fragment, useCallback, useContext} from 'react';
import Layout from "../../../../../../components/sales/layout/layout";
import TableSection from "../../../../../../components/sales/tableSection/tableSection";
import {BaseUrl} from "../../../../../../contexts/baseUrl/baseUrl";
import Images from "../../../../../../assets/images/imageData";
import {Link} from "react-router-dom";

const RTOCasesList = ({
                         caseListRequest,
                      match,
                         caseListResponse = [],

                    }) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const  [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState()
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id)
            setRoleId(window.localStorage.getItem('fusion-role'));
            await caseListRequest(0, 1, 'LOGGED_IN', 'B2C_BANK')
        })();
        setIsLoading(false);
    }, []);


    const headers = [
        'Unique ID',
        'Customer First Name',
        'Vehicle No',
        'Bank Name',
        'Loan Required Amount',
        'status',
        'Created At',
        'Created By',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await caseListRequest(0, val.selected + 1, 'LOGGED_IN', 'B2C');
        setIsLoading(false);
    };

    useEffect(() => {

        if (caseListResponse && caseListResponse?.data  &&
            caseListResponse?.data?.resultSets && caseListResponse?.data?.resultSets.length > 0) {
            const tableData = ['id','unique_id', 'customer_name', 'vehicle_registration_number', 'bank_name', 'loan_required_amount', 'status','created_at' ,'created_user_name'];
            const data = caseListResponse?.data?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'unique_id' ? {[key]: element['id']} : {[key]: element[key]}
                    )),
                    (element['status'] && (element['status'].toLocaleLowerCase() === 'payment rejected' || element['status'].toLocaleUpperCase() === 'DISBURSED' ||
                            element['status'].toLocaleUpperCase() === 'LOGGED_IN' ||
                            element['status'].toLocaleUpperCase() === 'APPROVED' || element['status'].toLocaleUpperCase() === 'REJECTED' || element['status'].toLocaleUpperCase() === 'CANCELLED')
                        || element['status'] === 'Request For Approval' || element['status'] === 'REQUEST_FOR_CASE_APPROVAL' || element['status'] === 'COMPLETE_PAYMENT_RELEASED' ||
                        element['status'] === 'REQUEST_FOR_PAYMENT_RELEASE_APPROVED' || element['status'] === 'PAYMENT_DETAILS_ADDED' || element['status'] === 'REQUEST_FOR_CASE_MODIFICATION'
                    || element['status'] === 'REQUEST_FOR_PAYMENT_RELEASE' || element['status'] === 'PARTIAL_PAYMENT_RELEASED') ?
                        {
                            Action: [
                                { name: 'View Details', link: `${baseUrl}/ucd/case-view`},
                                (parseInt(roleId) === 62 &&
                                    (element['status'].toLocaleLowerCase() === 'logged_in' || element['status'].toLocaleLowerCase() === 'logged in')
                                || (parseInt(roleId) === 62 && element['status'] === 'REQUEST_FOR_CASE_MODIFICATION'))
                                    ? {name: 'Edit', link: `${baseUrl}/ucd/case/save`} : "",
                                (parseInt(roleId) === 62 && (element['status'] === 'APPROVED' || element['status'] === 'REQUEST_FOR_PAYMENT_MODIFICATION' || element['status'] === 'PAYMENT_DETAILS_ADDED'))
                                ? { name: 'Payment Raise', link: `${baseUrl}/ucd/case/payment-raise-v2`} : "",
                                ((element['status'] === 'REQUEST_FOR_CASE_APPROVAL' && (parseInt(roleId) === 54 || parseInt(roleId) === 55))) ? {name: 'PennyDrop', link: `${baseUrl}/ucd/case/account-penny-drop`} : "",
                                (((element['status'].toLocaleLowerCase() !== 'logged_in' || element['status'].toLocaleLowerCase() !== 'logged in')
                                    && (parseInt(roleId) === 54 || parseInt(roleId) === 62))) ? {name: 'Tranches to Release Request', link: `${baseUrl}/ucd/case/loan-tranche-release-request`} : "",

                                // { name: 'Payment Release Request', link: `${baseUrl}/ucd/case/payment-raise-view`},
                            ]
                        }
                        : element['status'].toLocaleUpperCase() === 'APPROVED' &&
                        {
                            Action: [
                                parseInt(roleId) === 54 ? { name: 'Change Status', link: `${baseUrl}/ucd/case-view`} : "",
                                //
                                //  parseInt(roleId) === 54 ? {name: 'Change Status', link: "#"} : ""
                            ]
                        },
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(caseListResponse?.data?.total / caseListResponse?.data?.per_page));
        }
    }, [caseListResponse]);

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Link
                        to={`${baseUrl}/ucd/case/save`}
                        className="btn btn-primary d-md-inline-block"
                    >
                        {"Add Case"}
                        <img src={Images?.ArrowRight} alt="" />
                    </Link>
                </Fragment>
            </>
        );
    }

    return (
        <>
            <Layout
                title={"Case Listing"}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={caseListResponse?.data?.resultSets}
                    srNo={caseListResponse?.data?.from}
                />
            </Layout>
        </>
    )
};

export default RTOCasesList;
